import { LocalizedForm } from "common/localization";

export default class UserPasswordChangeForm extends LocalizedForm {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "password",
                    label:
                        "ADMINISTRATION.USER.PASSWORD_CHANGE.FIELDS.PASSWORD_LABEL",
                    type: "password",
                    placeholder:
                        "ADMINISTRATION.USER.PASSWORD_CHANGE.FIELDS.PASSWORD_PLACEHOLDER",
                    rules: [
                        "required",
                        "string",
                        "min:8",
                        "regex:/([^a-zA-Z\\d])+([a-zA-Z\\d])+|([a-zA-Z\\d])+([^a-zA-Z\\d])+/",
                    ],
                },
                {
                    name: "confirmPassword",
                    label:
                        "ADMINISTRATION.USER.PASSWORD_CHANGE.FIELDS.CONFIRM_PASSWORD_LABEL",
                    placeholder:
                        "ADMINISTRATION.USER.PASSWORD_CHANGE.FIELDS.CONFIRM_PASSWORD_PLACEHOLDER",
                    rules: "required|string|same:password",
                    type: "password",
                },
                {
                    name: "sendMailNotification",
                    label:
                        "ADMINISTRATION.USER.PASSWORD_CHANGE.FIELDS.SEND_PASSWORD_CHANGE_EMAIL_LABEL",
                    type: "checkbox",
                },
            ],
        };
    }
}
